/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'file-ppt-fill': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M8.188 8.5H7V5h1.188a1.75 1.75 0 110 3.5"/><path pid="1" d="M4 0h8a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V2a2 2 0 012-2m3 4a1 1 0 00-1 1v6.5a.5.5 0 001 0v-2h1.188a2.75 2.75 0 000-5.5z"/>',
    },
});
